// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip__tooltip___1OTf2"};